import React from 'react';

import './fixedOverlay.scss';

const FixedOverlay: React.FC = ({ children }) => (
    <div styleName="container">{children}</div>
);

export default FixedOverlay;
